<!-- eslint-disable max-lines -->
<template>
    <paper class="receiptTile">
        <m-pane
            :config="config"
            :initSearchInfo="initSearchInfo"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="searchTotalTitle"
            :loading="loading"
            :currentPage="currentPage"
            ref="tablePage"
            searchId="receipt_sign_search"
            pageID="receipt_sign"
            @row-db-click="rowDBclick"
            @detail-btn="detailBtn"
            @seal-btn="sealBtn"
            @photos-btn="photosBtn"
            @upload-btn="uploadBtn"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @hongHe-btn="hongHeBtn"
            @sizeChange="sizeChange"
            @btnClick="btnClick"
            @recheck-btn="recheckBtn"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT-OTP-RECEPITE-CENTER"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04050010'">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <el-tooltip effect="dark" content="批量上传" placement="top">
                    <span v-has="'otp04050001'"
                        ><el-dropdown class="mgl-10">
                            <el-button
                                icon="el-icon-upload2"
                                size="mini"
                            ></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <div @click="checkClick('选择', '')">
                                        选择
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <div
                                        @click="
                                            checkClick('合同号', 'contractNo')
                                        "
                                    >
                                        合同号
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <div
                                        @click="
                                            checkClick(
                                                '客户订单号',
                                                'custOrderNo'
                                            )
                                        "
                                    >
                                        客户订单号
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <div
                                        @click="
                                            checkClick('发车单号', 'dispatchNo')
                                        "
                                    >
                                        发车单号
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <div
                                        @click="
                                            checkClick('集配单号', 'collectNo')
                                        "
                                    >
                                        集配单号
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown></span
                    >
                </el-tooltip>
            </div>

            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    @click="confirmation"
                    v-has="'otp04050002'"
                    >签收</el-button
                >
                <el-button type="primary" @click="overdue" v-has="'otp04050003'"
                    >逾 期</el-button
                >
                <el-button
                    type="primary"
                    @click="abnormalApproval"
                    v-has="'otp04050009'"
                    >异常审批</el-button
                >
            </div>
        </m-pane>

        <!-- 签收/拒收/详情 弹框 -->
        <sign-in-dialog
            v-if="signInShow"
            :signInShow.sync="signInShow"
            :titleName="titleName"
            :rowData="rowData"
            :searchObj="searchObj"
            @refreshList="getDataList"
        >
        </sign-in-dialog>

        <!-- 逾期弹框 -->
        <overdue-dialog
            :searchObj="searchObj"
            :selectData="selectData"
            :overdueShaowDialog.sync="overdueShaowDialog"
            v-if="overdueShaowDialog"
            :overdueCauseTypeOptions="overdueCauseTypeOptions"
            :overdueTypeOptions="overdueTypeOptions"
            @refreshList="getDataList"
        >
        </overdue-dialog>

        <!-- 列配置按钮左边那个批量上传弹框 -->
        <batch-upload-dialog
            v-if="batchUploadShow"
            :batchFlag="batchFlag"
            :batchUploadShow.sync="batchUploadShow"
            :batchUploadTitle="batchUploadTitle"
            :selectData="selectData"
            :searchObj="searchObj"
            @refreshList="getDataList"
        >
        </batch-upload-dialog>

        <!-- 附件 弹框 -->
        <attachment-dialog
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        >
        </attachment-dialog>

        <!-- 列表 逾期明细弹框 -->
        <list-overdue-dialog
            v-if="listOverdueShow"
            :listOverdueShow.sync="listOverdueShow"
            :overdueTypeOptions="overdueTypeOptions"
            :rowData="rowData"
            :overdueCauseTypeOptions="overdueCauseTypeOptions"
        >
        </list-overdue-dialog>

        <!-- 上传按钮使用的组件 -->
        <upload-new-btn
            ref="uploadButton"
            type="btn"
            multiple
            businessKey="default"
            bucket="srm"
            contentType="application/octet-stream"
            :needBtn="false"
            :publicRead="1"
            :compressImage="true"
            :compressQuality="0.5"
            @beforeUpload="beforeUpload"
            @callback="uploadResponse"
        >
            <i ref="upload"></i>
        </upload-new-btn>
        <!-- 最后一公里项目 新建详情页 -->
        <Details
            v-if="detailsShow"
            :detailsShow.sync="detailsShow"
            :titleName="titleName"
            :rowData="rowData"
            :searchObj="searchObj"
            @detailsClose="detailsClose"
            @refreshList="getDataList"
        ></Details>

        <!-- 回单印鉴 弹框 -->
        <SealDialog
            v-if="sealShow"
            :sealShow.sync="sealShow"
            :rowData="rowData"
        ></SealDialog>

        <!-- 反查 弹框 -->
        <ReviewDialog
            isSignCenter
            v-if="reviewShow"
            :reviewShow.sync="reviewShow"
            :rowData="rowData"
            @finish="getDataList(searchObj)"
        ></ReviewDialog>
        <hong-he-dialog
            v-if="hongHeDialogVisible"
            :hongHeDialogVisible.sync="hongHeDialogVisible"
            :rowData="rowData"
            @hongHeDialogClose="hongHeDialogClose"
        >
        </hong-he-dialog>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import signInDialog from './signInDialog';
import overdueDialog from './overdueDialog';
import attachmentDialog from './attachmentDialog';
import batchUploadDialog from './batchUploadDialog';
import Details from './details/Details';
import SealDialog from './SealDialog';
import ReviewDialog from '../receiptReviewManage/ReviewDialog';
import { receiptList, receiptSign, receiptUpload, userdataAuth, abnormalApprove, getIflowStatus, getTotalCounts } from '../../../api/receiptSign';
import { getDictionaryDetailByCode } from '../../../api/common';
import { mapState } from 'vuex';
import listOverdueDialog from './listOverdueDialog.vue';
import reportExport from '@/components/lots/reportExportPlugin';
import common from '@/utils/common.js';
import { dictWithUrl } from '@/components/lots/api.js';
import 'viewerjs/dist/viewer.css';
import dayjs from 'dayjs';
import hongHeDialog from './hongHe/hongHeDialog';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    name: 'receiptSign',
    components: { mPane, paper, signInDialog, overdueDialog, batchUploadDialog, attachmentDialog, UploadNewBtn, reportExport, listOverdueDialog, Details, SealDialog, ReviewDialog, hongHeDialog },
    data () {
        return {
            initSearchInfo: {},
            cancelRequest: () => { }, // 调用 取消未响应的鉴权请求
            projectClassify: {}, // 项目分类
            siteCodeList: [], // 用户可展示平台数据控制
            reviewShow: false,
            listOverdueShow: false,
            sealShow: false,
            batchFlag: '', // 批量上传标识符
            currentPage: 1,
            rowData: {}, // 签收 拒收 查看详情弹框数据
            batchUploadTitle: '',
            overdueCauseTypeOptions: {}, // 逾期原因
            overdueTypeOptions: [], // 逾期类型
            selectData: [], // 已选中数据
            overdueShaowDialog: false, // 拒收弹框 显隐
            attachmentShow: false, // 附件弹框 显隐
            searchObj: {
                pageNo: 1,
                pageSize: 10
            }, // 首页数据查询的数据对象
            titleName: '',
            signInShow: false,
            isRejects: false,
            isReceive: true,
            isRejection: false,
            isCondition: false,
            textarea: '',
            imageUrl: '',
            batchUploadShow: false,
            times: '',
            inputName: '',
            imgArr: [],
            // 高级搜索配置项
            searchTotalTitle: config.searchTotalTitle,
            pageTotal: 0, // 数据总条数
            totalData: [], // 首页表格数据
            loading: false, // 加载中 动画
            config,
            timeNum: 0,
            exportParams: {},
            isFirstSearch: true,
            detailsShow: false,
            hongHeDialogVisible: false,
            optionNum: ['SIGN_STATUS', 'ORDER_TYPE', 'OTP_TRANSPORT_FEE_STATUS', 'OTP_TMS_PROCUREMENT_CHANNEL',
                'DELIVERED_VERIFY_FLAG', 'SOURCE_SYSTEM', 'TASK_TYPE', 'SYS_MIP_IFLOW_STATUS', 'SIGN_TYPE', 'DELIVERY_TYPE']
        };
    },
    methods: {
        getFileExt (fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        beforeUpload ({ file }) {
            var extArr = ['jpg', 'jpeg', 'png', 'tif', 'bmp'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / TIF / BMP',
                    duration: 5000,
                    showClose: true
                });
                this.$refs.uploadButton.handleUploadStatus(false);
                this.handleDeleteErrorFile(file);
                return false;
            }
        },
        handleDeleteErrorFile (file) { // 清除不符合规格的文件
            this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.forEach((e, i) => {
                if (file.name === e.name) {
                    this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.splice(i, 1);
                }
            });
            this.$refs.uploadButton.uploadDataArr.forEach((e, i) => {
                if (file.name === e.file.name) {
                    this.$refs.uploadButton.uploadDataArr.splice(i, 1);
                }
            });
        },
        uploadResponse (response) {
            const params = {
                createUserName: this.user.userName,
                createUserCode: this.user.userCode,
                signFileUpload: 'N',
                taskNoList: [this.rowData.taskNo],
                receiptSource: '10'
            };
            params.fileUrls = response.map(item => item.data.downUrl);
            receiptUpload(params).then(res => {
                this.loading = false;
                if (res) {
                    if (res.data.length > 0) {
                        let message = '';
                        res.data.forEach(item => {
                            message += `<div style='line-height: 30px;'>
                                        <span style='color: #909399;'>图片</span>
                                        <span style='color: #F56C6C;'>${item.pictureName}</span>
                                        <span style='color: #409EFF;'>${item.message}</span>
                                    <div>`;
                        });
                        const duration = 5000 + res.data.length * 1500;
                        this.$message({
                            type: 'warning',
                            duration,
                            dangerouslyUseHTMLString: true,
                            message,
                            showClose: true
                        });
                    } else {
                        this.getDataList(this.searchObj);
                        this.$message.success('上传成功');
                    }
                }
            }).catch(() => {
                this.loading = false;
                this.$message.error('上传失败');
            });
        },
        detailBtn (data) {
            this.rowData = data;
            this.listOverdueShow = true;
        },
        sealBtn (data) {
            this.rowData = data;
            this.sealShow = true;
        },
        photosBtn (data) {
            this.rowData = data;
            this.attachmentShow = true;
        },
        uploadBtn (data) {
            this.rowData = data;
            // 未收款不允许上传回单
            if (+data.goodsFeeStatus === 1 || +data.transportFeeStatus === 1) {
                this.$message.warning('请收款后再上传回单！');
            } else {
                this.$refs.upload.click();
            }
        },
        recheckBtn (data) {
            this.rowData = data;
            this.reviewShow = true;
        },
        // 拒收
        editBtn (data) {
            data.clickBtn = 'reject';
            this.rowData = data;
            const getCollectionRes = this.getCollectionRes([data]);
            if (getCollectionRes.length > 0) {
                return this.$message.warning(`到付 或 代收的单需要先上传回单再拒收，请先上传回单！`);
            }
            this.titleName = '回单拒收';
            this.detailsShow = true;
        },
        // 签收
        checkBtn (data) {
            data.clickBtn = 'sign';
            this.rowData = data;
            const getCollectionRes = this.getCollectionRes([data]);
            if (getCollectionRes.length > 0) {
                return this.$message.warning(`到付 或 代收的单需要先上传回单再签收，请先上传回单！`);
            }
            this.titleName = '回单签收';
            this.detailsShow = true;
        },
        hongHeBtn (data) {
            this.rowData = data;
            this.hongHeDialogVisible = true;
        },
        hongHeDialogClose () {
            this.hongHeDialogVisible = false;
            this.getDataList(this.searchObj);
        },
        // 双击查看详情
        rowDBclick (data) {
            data.clickBtn = 'detail';
            this.rowData = data;
            this.titleName = '回单详情';
            this.detailsShow = true;
        },
        // 页码改变
        pageChange (data) {
            this.searchObj.pageNo = data;
            this.getDataList(this.searchObj, true);
        },
        // 页容量改变
        sizeChange (data) {
            this.searchObj.pageSize = data;
            this.searchObj.pageNo = 1;
            this.getDataList(this.searchObj, true);
        },
        btnClick (val, index, row) {
            const params = {
                iflowId: row.iflowId,
                iflowMan: row.iflowMan
            };
            getIflowStatus(params).then(res => {
                if (+res.code === 0) {
                    row.iflowStatus = res.data;
                    if (row.iflowLink) {
                        if (['10', '11'].includes(row.iflowStatus)) {
                            row.iflowLink = row.iflowLink.replace('view', 'edit');
                        }
                        window.open(row.iflowLink);
                    }
                }
            });
        },
        // 查询
        _validateSearchParams (data) {
            const beginDate = (data.searchTime && dayjs(data.searchTime[0]).valueOf()) || 0;
            const endDate = (data.searchTime && dayjs(data.searchTime[1]).valueOf()) || 0;
            if (!data.customerOrderNo && !data.searchTime) {
                return '客户订单号 和 创建时间 不可同时为空';
            }
            const differenceValue = endDate - beginDate;
            const maxDay63 = 1000 * 60 * 60 * 24 * 63;
            if (differenceValue > maxDay63) {
                return '按时间查询或导出时，查询或导出时间跨度不可超过两个月！';
            }
        },
        // 查询
        searchChange (data) {
            this._searchData = data;
            if (this._validateSearchParams(this._searchData)) return this.$message.warning(this._validateSearchParams(this._searchData));
            this.isFirstSearch = false;
            this.searchObj = { ...this.searchObj, ...data };
            this.searchObj.signStatus = data.signStatus && data.signStatus.join();
            this.searchObj.custOrderNo = data.customerOrderNo;
            this.searchObj.beginDate2 = data.searchTime && common.formatDateTime(data.searchTime[0]);
            this.searchObj.endDate2 = data.searchTime && common.formatDateTime(data.searchTime[1]);
            this.searchObj.beginDate3 = data.signTime && common.formatDateTime(data.signTime[0]);
            this.searchObj.endDate3 = data.signTime && common.formatDateTime(data.signTime[1]);
            this.searchObj.pageNo = 1;
            this.getDataList(this.searchObj);
        },
        selectChange (data) {
            this.selectData = data;
        },
        getProjectClassify () {
            return getDictionaryDetailByCode({ dictCodes: 'PROJECT_CLASSIFY' }).then(res => {
                if (res) {
                    this.projectClassify = res.data.PROJECT_CLASSIFY || {};
                }
            }).catch(() => {
            });
        },
        // 获取逾期原因
        getOverdueOptions () {
            let optionNums = '';
            optionNums += 'OVER_DUE_TYPE, '; // 逾期类型
            optionNums += 'OVERDUE_ARRIVE_1, '; // 到货逾期一级原因
            optionNums += 'OVERDUE_ARRIVE_2, '; // 到货逾期二级原因
            optionNums += 'OVERDUE_ARRIVE_1, '; // 回单逾期一级原因
            optionNums += 'OVERDUE_RECEIPT_2'; // 回单逾期二级原因
            return getDictionaryDetailByCode({ dictCodes: optionNums }).then(res => {
                if (res) {
                    const getOptions = (params) => {
                        return Object.entries(res.data[params]).map(item => ({ value: item[0], label: item[1] }));
                    };
                    this.overdueTypeOptions = getOptions('OVER_DUE_TYPE'); // 逾期类型
                    const OTP_CHANGE_DELIVERY_2 = getOptions('OVERDUE_ARRIVE_2'); // 到货逾期二级原因
                    const OTP_CHANGE_RECEIPT_2 = getOptions('OVERDUE_RECEIPT_2'); // 回单逾期二级原因
                    const overdueCauseTypeOptions = {};
                    overdueCauseTypeOptions['0'] = getOptions('OVERDUE_ARRIVE_1');
                    overdueCauseTypeOptions['1'] = getOptions('OVERDUE_ARRIVE_1');
                    const getOptionsLevel2 = (key, level2) => {
                        overdueCauseTypeOptions[key].forEach(item => {
                            item.children = level2.filter(item2 => {
                                if (item2.value.indexOf(item.value) === 0) {
                                    return true;
                                }
                            });
                        });
                    };
                    getOptionsLevel2('0', OTP_CHANGE_DELIVERY_2);
                    getOptionsLevel2('1', OTP_CHANGE_RECEIPT_2);
                    this.overdueCauseTypeOptions = overdueCauseTypeOptions;
                }
            }).catch(() => {
            });
        },
        // eslint-disable-next-line
        async getDataList ({ senderCityCode, senderCityName, senderDistrictCode, senderDistrictName, senderTownCode, senderTownName, receiverCityCode, receiverCityName, receiverDistrictCode, receiverDistrictName, receiverTownCode, receiverTownName, isNetCheck, custOrderNo, taskNo, signStatus, beginDate2, endDate2, beginDate3, endDate3, supplierCode, customerCode, siteCode, receiptSource, dispatchNo, receiptStatus, projectClassify, businessMode, contractNo, signIsFull, carrierCode, pageNo, pageSize, procurementChannel, orderNo, waybillNo, carrierVisibleFlag, upperReceiverName, collectNo, orderType, deliveredVerifyFlag, taskType, sourceSystem, collectionFlag, deliverypayType, goodsFeeStatus, transportFeeStatus, transportStatus, transReceiverName, receiverTel, receiverMobile } = { pageNo: 1, pageSize: 10 }, searchCountFlag) {
            // eslint-disable-next-line
            const params = { senderCityCode, senderCityName, senderDistrictCode, senderDistrictName, senderTownCode, senderTownName, receiverCityCode, receiverCityName, receiverDistrictCode, receiverDistrictName, receiverTownCode, receiverTownName, isNetCheck, custOrderNo, taskNo, signStatus, beginDate2, endDate2, beginDate3, endDate3, supplierCode, customerCode, siteCode, receiptSource, dispatchNo, receiptStatus, projectClassify, businessMode, contractNo, signIsFull, carrierCode, pageNo, pageSize, procurementChannel, orderNo, waybillNo, carrierVisibleFlag, upperReceiverName, collectNo, orderType, deliveredVerifyFlag, taskType, sourceSystem, collectionFlag, deliverypayType, goodsFeeStatus, transportFeeStatus, transportStatus, transReceiverName, receiverTel, receiverMobile };
            // eslint-disable-next-line
            const exportParams = { senderCityCode, senderCityName, senderDistrictCode, senderDistrictName, senderTownCode, senderTownName, receiverCityCode, receiverCityName, receiverDistrictCode, receiverDistrictName, receiverTownCode, receiverTownName, isNetCheck, custOrderNo, taskNo, signStatus, beginDate2, endDate2, supplierCode, customerCode, siteCode, receiptSource, dispatchNo, receiptStatus, projectClassify, businessMode, contractNo, signIsFull, carrierCode, pageNo, pageSize, procurementChannel, orderNo, waybillNo, carrierVisibleFlag, upperReceiverName, collectNo, orderType, deliveredVerifyFlag, taskType, sourceSystem, collectionFlag, deliverypayType, goodsFeeStatus, transportFeeStatus, transportStatus, transReceiverName, receiverTel, receiverMobile };
            this.searchObj = params;
            this.currentPage = pageNo;
            this.loading = true;
            params.siteCodeList = this.siteCodeList.join(); // 用户可展示平台数据控制
            // 导出变量
            this.exportParams = {
                ...exportParams,
                signStatus: this.strToArr(params.signStatus),
                siteCodeList: this.strToArr(params.siteCodeList)
            };
            if (!params.beginDate3) { delete this.initSearchInfo.signTime; }
            const dict = await dictWithUrl(this.optionNum.join(','));
            const dictData = dict.data;
            return receiptList(params).then(async res => {
                if (res) {
                    const receiptSource = {
                        '0': 'APP端',
                        '10': 'PC端',
                        '20': '微信'
                    };
                    const signIsFullText = {
                        Y: '是',
                        N: '否'
                    };
                    res.data.list.forEach(item => {
                        item.distributionLastFlagName = item.distributionLastFlag === 'Y' ? '是' : '否';
                        item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                        item.signStatusText = dictData.SIGN_STATUS[item.signStatus] || item.signStatus;
                        item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || item.orderType;
                        item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSyste] || item.sourceSyste;
                        item.taskTypeName = dictData.TASK_TYPE[item.taskType] || item.taskType;
                        item.procurementChannelText = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                        item.receiptSourceText = receiptSource[item.receiptSource];
                        item.projectClassifyText = this.projectClassify[item.projectClassify];
                        item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
                        item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
                        // B2B没有拒收 网批属于B2B             分拨第一阶段 且为 B2C 的单 没有拒收
                        item.hiddenEvent = [];
                        if ((item.businessMode === 'B2B' && item.sourceSystem !== 'CAINIAO') ||
                            (item.businessMode === 'B2C' && item.distributionFlag === 'Y' && item.distributionNum === 1) ||
                            (item.sourceSystem === 'CIMS' && item.businessMode === 'B2C' && item.projectClassify === 'WP')
                        ) {
                            item.hiddenEvent = ['edit'];
                        }
                        if (item.signStatus === '70') {
                            item.hiddenEvent = ['edit'];
                        } else if (item.signStatus === '100') {
                            item.hiddenEvent = ['view', 'edit'];
                        } else if (item.signStatus === '200') {
                            item.hiddenEvent = ['view', 'edit'];
                        }
                        if (item.recheckAble === '0') {
                            item.hiddenEvent.push('recheck');
                        }
                        if (item.businessMode !== 'B2C' || item.sourceSystem !== 'HONGHE') {
                            item.hiddenEvent.push('hongHe');
                        }
                        item.showPhotos = item.files.length > 0;

                        if (item.signIsFull !== null) {
                            item.signIsFullText = signIsFullText[item.signIsFull] || '';
                        }
                        if (item.signStatus === '60') { // 待签收状态下，是否完好显示空值
                            item.signIsFullText = '';
                        }
                        item.receiptStatusText = item.receiptStatus === '0' ? '未上传' : '已上传';
                        item.iflowStatusName = dictData.SYS_MIP_IFLOW_STATUS[item.iflowStatus] || item.iflowStatus;
                        item.deliveredVerifyFlagName = dictData.DELIVERED_VERIFY_FLAG[item.deliveredVerifyFlag] || item.deliveredVerifyFlag;
                        item.signTypeName = dictData.SIGN_TYPE[item.signType] || item.signType;
                        if (item.iflowLink) {
                            item.iflowLinkName = '审批';
                        }
                        item.expectArriveEndTime = item.expectArriveEndTime || item.expectArriveStartTime;
                        item.hongheFlagName = item.hongheFlag === 0 ? '待审核' : item.hongheFlag === 1 ? '审核驳回' : item.hongheFlag === 2 ? '审核通过' : '';
                    });
                    this.totalData = res.data.list || [];
                    if (!searchCountFlag) { this.getPageTotal(params); }
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        async getPageTotal (params) {
            const totalCountRes = await getTotalCounts(params);
            this.pageTotal = totalCountRes ? totalCountRes.data : 10000;
        },
        strToArr (str) {
            if (str) return str.split(',');
            return [];
        },
        getCollectionRes (selectData) {
            const taskNoArr = [];
            selectData.forEach(item => {
                if (
                    (item.collectionFlag === 'Y' || +item.deliverypayType === 2) &&
                    +item.receiptStatus !== 1
                ) {
                    taskNoArr.push(item.taskNo);
                }
            });
            return taskNoArr;
        },
        confirmation () {
            if (this.loading) return false; // 如果表格loading中，不允许签收
            if (!this.selectData.length) {
                this.$message({
                    message: '请选择运输单',
                    type: 'warning'
                });
                return false;
            }
            const params = [];
            const taskNos = [];
            const getCollectionRes = this.getCollectionRes(this.selectData);
            if (getCollectionRes.length > 0) {
                return this.$message.warning(`任务号：${getCollectionRes.join('，')}，到付 或 代收的单需要先上传回单再签收，请先上传回单！`);
            }
            this.selectData.forEach(item => {
                if (+item.deliveredVerifyFlag === 2 && +item.iflowStatus !== 30) {
                    taskNos.push({ taskNo: item.taskNo });
                } else {
                    params.push({
                        signContact: this.user.userName,
                        batchSignFlag: '0',
                        signType: 'PC',
                        receiptResponse: {
                            taskNo: item.taskNo,
                            custOrderNo: item.custOrderNo,
                            version: item.version
                        },
                        receiptDetailResponse: {}
                    });
                }
            });
            if (taskNos.length) {
                let message = '';
                taskNos.forEach(item => {
                    message += `<div style='line-height: 30px;'>
                                        <span style='color: #909399;'>运输单号</span>
                                        <span style='color: #F56C6C;'>${item.taskNo}</span>
                                        <span style='color: #409EFF;'>请到直通宝/美的通/收货短信做电子签收!</span>
                                    <div>`;
                });
                const duration = 3000 + taskNos.length * 1500;
                this.$message({
                    type: 'warning',
                    duration,
                    dangerouslyUseHTMLString: true,
                    message,
                    showClose: true
                });
            }
            if (!params.length) return false;
            this.loading = true;
            receiptSign(params).then(res => {
                if (!res) {
                    this.loading = false;
                    return false;
                }
                this.getDataList(this.searchObj);
                if (!res.data.length) {
                    this.$message({
                        message: '签收成功',
                        type: 'success'
                    });
                    return false;
                }
                let message = '';
                res.data.forEach(item => {
                    message += `<div style='line-height: 30px;'>
                                        <span style='color: #909399;'>运输单号</span>
                                        <span style='color: #F56C6C;'>${item.taskNo}</span>
                                        <span style='color: #409EFF;'>${item.message}</span>
                                    <div>`;
                });
                const duration = 5000 + res.data.length * 1500;
                this.$message({
                    type: 'warning',
                    duration,
                    dangerouslyUseHTMLString: true,
                    message,
                    showClose: true
                });
            }).catch(() => {
                this.loading = false;
            });
        },
        overdue () {
            if (this.loading) return false; // 如果表格loading中，不允许逾期
            if (!this.selectData.length) {
                this.$message({
                    message: '请选择运单',
                    type: 'warning'
                });
                return false;
            }
            this.overdueShaowDialog = true;
        },
        // 异常审批
        abnormalApproval () {
            if (!this.selectData.length) { return this.$message.warning('请选择运单！'); }
            if (this.selectData.length > 1) { return this.$message.warning('每次只能勾选一单操作！'); }
            if (!(+this.selectData[0].deliveredVerifyFlag === 2 && this.selectData[0].deliveryType !== 'NET')) return this.$message.warning('只有电子签收且非网点配送的单才可以发起异常审批！');
            if (this.selectData[0].iflowStatus !== '00' && this.selectData[0].iflowLink) return this.$message.warning('已发起过异常审批流程的不可再次发起！');
            const params = { taskNo: this.selectData[0].taskNo };
            abnormalApprove(params).then(res => {
                if (+res.code === 0) {
                    window.open(res.data);
                    this.getDataList(this.searchObj);
                }
            });
        },
        checkClick (batchUploadTitle, batchFlag) {
            if (batchUploadTitle === '选择' && !this.selectData.length) {
                this.$message.warning('至少选择一条数据');
                return false;
            }
            this.batchUploadTitle = batchUploadTitle;
            this.batchFlag = batchFlag;
            this.batchUploadShow = true;
        },
        userAuthorization () {
            return userdataAuth(this.user.userCode).then(res => {
                if (res) {
                    const hasAuth = res.data.find(item => item.dataCode === 'D20190621009');
                    if (hasAuth) {
                        let authCodeArr = hasAuth.userDataAuths.map(item => item.authCode);
                        if (authCodeArr.find(item => item === 'ALL')) {
                            authCodeArr = [];
                        }
                        this.siteCodeList = authCodeArr;
                    }
                }
            });
        },
        initDate (timeNum) {
            const start = new Date();
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);
            start.setMilliseconds(0);
            const end = new Date();
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);
            end.setMilliseconds(0);
            start.setTime(start.getTime() - 3600 * 1000 * 24 * timeNum);
            return [start, end];
        },
        async initData () {
            const params = {
                signStatus: '',
                beginDate3: '',
                endDate3: '',
                pageNo: 1,
                pageSize: 10
            };
            const dateArr = this.initDate(this.config.searchList.searchTxt[1].timeNum);
            params.beginDate2 = dayjs(dateArr[0]).format('YYYY-MM-DD HH:mm:ss');
            params.endDate2 = dayjs(dateArr[1]).format('YYYY-MM-DD HH:mm:ss');

            params['carrierVisibleFlag'] = 'Y';
            params['carrierCode'] = this.supplier.supplierCode;
            const query = this.$route.query;
            if (query.transportStatus) {
                this.initSearchInfo = {
                    receiptStatus: query.receiptStatus,
                    transportStatus: query.transportStatus
                };
                params['receiptStatus'] = query.receiptStatus;
                params['transportStatus'] = query.transportStatus;
            }
            const initSearchInfo = {};
            if (query.isRefresh) {
                const searchSet = this.$refs.tablePage.$refs.searchList.$refs.searchSet || [];
                const searchData = searchSet[0].searchData || {};
                searchData.signTime = []; // 特殊处理跳转过来时间需要重新赋值，不然页面不会初始化
                params.signStatus = query.orderStatusList;
                params.beginDate3 = query.createStartTime && common.formatDateTime(query.createStartTime);
                params.endDate3 = query.createEndTime && common.formatDateTime(query.createEndTime);
                params.beginDate2 = query.beginDate2 && common.formatDateTime(query.beginDate2);
                params.endDate2 = query.endDate2 && common.formatDateTime(query.endDate2);
                if (params.beginDate3) {
                    initSearchInfo.signTime = [params.beginDate3, params.endDate3];
                    searchData.signTime = [params.beginDate3, params.endDate3];
                }
                if (params.beginDate2) initSearchInfo.searchTime = [params.beginDate2, params.endDate2];
                initSearchInfo.signStatus = params.signStatus.split(',');
                this.$router.replace({ name: 'receiptSign', query: {} });
                this.isFirstSearch = false;
            } else {
                initSearchInfo.signTime = [];
                initSearchInfo.signStatus = '';
            }
            this.initSearchInfo = initSearchInfo;
            this.searchParams = Object.assign({}, {
                pageSize: 10,
                pageNo: 1
            }, initSearchInfo);
            this._searchData = {
                ...params,
                signTime: initSearchInfo.signTime,
                searchTime: initSearchInfo.searchTime
            };
            // 获取权限列表
            await this.userAuthorization();
            // 获取项目分类
            await this.getProjectClassify();
            // 获取逾期原因
            await this.getOverdueOptions();
            // 获取列表数据
            await this.getDataList(params);
        },
        exportFile (submit) {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams(this._searchData)) return isFirstSearch ? '' : this.$message.warning(this._validateSearchParams(this._searchData));
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode, carrierCode: this.supplier.supplierCode });
            this.isFirstSearch = false;
        },
        detailsClose () {
            this.detailsShow = false;
        },
        // 获取基础数据
        async getBaseData () {
            await dictWithUrl('SYS_MIP_IFLOW_STATUS,OTP_TRANSPORT_FEE_STATUS');
        }

    },
    activated () {
        if (this.$route.query.transportStatus) {
            this.initData();
        }
    },
    created () {
        this.getBaseData();
    },
    mounted () {
        // 获取权限列表
        this.userAuthorization();
        // 获取项目分类
        this.getProjectClassify();
        // 获取逾期原因
        this.getOverdueOptions();
    },
    computed: {
        ...mapState({
            user: state => state.user,
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        })
    },
    beforeRouteLeave (to, from, next) {
        this.cancelRequest(); // 取消未响应的鉴权请求
        clearTimeout(this.timeNum);
        next();
    }
};
</script>

<style lang="less">
.viewer-backdrop {
    background-color: #fff;
}
.viewer-backdrop.viewer-fixed {
    background-color: rgba(0, 0, 0, 0.5);
    .viewer-navbar {
        height: auto;
    }
}
.viewer-navbar {
    height: 0;
}
.viewer-button {
    width: 60px;
    height: 60px;
    top: -30px;
    right: -30px;
}
.viewer-button::before {
    bottom: 10px;
    left: 10px;
}
.viewer-button.viewer-fullscreen-exit {
    width: 80px;
    height: 80px;
    top: -40px;
    right: -40px;
}
.viewer-button.viewer-fullscreen-exit::before {
    bottom: 15px;
    left: 15px;
}
.viewer-toolbar > ul > .viewer-small {
    margin: 3px 8px;
}
.receiptTile {
    .mgl-10 {
        margin-left: 10px;
    }
    .avatar-uploader {
        display: none;
    }
    .el-dropdown-menu__item {
        width: 100px;
        text-align: center;
        padding: 0 !important;
    }
    .el-button--text {
        padding: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item {
        height: 80px;
        width: 80px;
    }
    .el-upload-list__item-actions {
        height: 80px;
        width: 80px;
    }
}
</style>
